import React, { createContext, useContext } from 'react';
import type { ProductSubscription } from 'expo-iap';

// Mirrors the native provider's IReconcileResult (the platform pair duplicates its context types).
type IReconcileResult = { failures: number; granted: number };

interface IAPContextProps {
  connected: boolean;
  subscriptions: ProductSubscription[];
  isProcessing: boolean;
  connectionError: string | null;
  activeSubscriptionId: string | null;
  handlePurchase: (productId: string) => Promise<void>;
  handleRestorePurchases: () => Promise<void>;
  handleManageSubscription: () => Promise<void>;
  reconcile: (recoverOrphans?: boolean) => Promise<IReconcileResult>;
}

const noop = async () => {};

const IAPContext = createContext<IAPContextProps | undefined>(undefined);

interface IAPProviderProps {
  children: React.ReactNode;
}

export const IAPProvider: React.FC<IAPProviderProps> = ({ children }) => {
  return <>{children}</>;
};

export const useIAPContext = () => {
  const context = useContext(IAPContext);
  if (!context) {
    return {
      connected: false,
      subscriptions: [] as ProductSubscription[],
      isProcessing: false,
      connectionError: null,
      activeSubscriptionId: null,
      handlePurchase: noop,
      handleRestorePurchases: noop,
      handleManageSubscription: noop,
      reconcile: async () => ({ failures: 0, granted: 0 }),
    } satisfies IAPContextProps;
  }
  return context;
};
